import HTMLElement from 'node-html-parser/dist/nodes/html';

export const replaceRelLink = (markup: HTMLElement) => {
  const links = markup.querySelectorAll('a');

  Array.from(links).forEach((link) => {
    const goto = 'goto.ashx';
    const domain = 'sravni.ru';
    const href = link.getAttribute('href');

    try {
      const { pathname, host } = new URL(href);
      if ((pathname.includes(goto) && host.includes(domain)) || !host.includes(domain)) {
        link.setAttribute('rel', 'nofollow');
      } else if (!pathname.includes(goto) && host.includes(domain)) {
        link.removeAttribute('rel');
      }
    } catch (e) {
      console.error(e);
    }
  });

  return markup;
};
